module.exports = __webpack_public_path__ + "static/media/html.9150847e.jpg";